import React from 'react'
import PreEExceptionConfirmationDialog from "../PreEExceptionConfirmationDialog";
import PreEExceptionDialogBody from "../PreEExceptionFields";

const PreEExceptDialog = ({onClose,onSave,onEdit,onDelete, ...props}) =>
    
    <PreEExceptionConfirmationDialog   id={'preEExceptionDialogue'}
        {...props}
        cancelButton={{
            action: onClose,
            label: 'Close'
        }}

        acceptButton={{
            action: onSave,
            label: 'Save'
        }}
        editButton={{
            action: onEdit,
            label: 'Edit'
        }}

        deleteButton={{
            action:onDelete,
            label: 'Delete'
        }}

        onClose={onClose}

        header="Energization Approval Exception"

        body = {<PreEExceptionDialogBody {...props}/>}

      />

export default PreEExceptDialog;
